import React from 'react';
import { useQuery } from '@apollo/client';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { QUERY_USER_CLASSE } from '../../graphql/query/user/queryUserAccount';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { capture } from '../../services/sentry/capture';
import { MY_ID } from '../../helpers/user/authorization';
import { NoQuizzView } from './NoQuizz.view';
import { QueryUserClasseQuery } from '../../graphql/generated/graphql';
import { ClasseDate } from '../../types/classe/classe.def';

export const NoQuizz = () => {
  const { loading, error, data } = useQuery<QueryUserClasseQuery>(
    QUERY_USER_CLASSE,
    {
      variables: { id: MY_ID }
    }
  );
  if (loading) return <LoadingLayout />;
  if (error) {
    capture(error);
    return (
      <ContainerFullWidth>
        <p>Aucun challenge pour le moment.</p>
      </ContainerFullWidth>
    );
  }
  const classe: ClasseDate = {
    debut: data.getUserClasse.debut,
    fin: data.getUserClasse.fin
  };
  return <NoQuizzView classe={classe} />;
};
